// extracted by mini-css-extract-plugin
export default {"root":"cn8dGbwGeL"};